module.exports = __webpack_public_path__ + "img/state_void.f917038a.png";